import React, { useState } from 'react';
import { api } from '../api';

export default function ForcePassword({ user, onDone }) {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit(e) {
    e.preventDefault();
    if (pw.length < 8) { setErr('Password must be at least 8 characters'); return; }
    if (pw !== pw2) { setErr('Passwords do not match'); return; }
    setBusy(true); setErr('');
    try {
      const res = await api.changePassword(pw);
      onDone(res.user);
    } catch (ex) {
      const d = ex?.response?.data?.detail;
      setErr(typeof d === 'string' ? d : 'Could not update password — try again');
    }
    setBusy(false);
  }
  return (
    <div className="auth-overlay">
      <form className="auth-card" onSubmit={submit} data-testid="force-password-card">
        <h1>Set your password</h1>
        <p className="field-hint">Hi {user.name || user.email} — you signed in with a temporary password. Choose your own password to continue (minimum 8 characters).</p>
        <div className="field"><label className="field-label">New password</label>
          <input className="input" data-testid="force-password-input" type="password" value={pw} onChange={e => setPw(e.target.value)} autoComplete="new-password" autoFocus /></div>
        <div className="field"><label className="field-label">Confirm password</label>
          <input className="input" data-testid="force-password-confirm" type="password" value={pw2} onChange={e => setPw2(e.target.value)} autoComplete="new-password" /></div>
        {err && <div className="auth-error" data-testid="force-password-error">{err}</div>}
        <button className="btn btn-primary" data-testid="force-password-submit" type="submit" disabled={busy} style={{ width: '100%' }}>
          {busy ? 'Saving…' : 'Save password & continue'}
        </button>
      </form>
    </div>
  );
}
